module.exports = __webpack_public_path__ + "media/images/front/treatment_support/setting_add_home_screen/img04-6fd0327a1f1be83f7742306f20beb56f.png";